import dispatcher from "../Dispatcher/Dispatcher";
import { EventEmitter } from "events";
import EmailConstants from "../Constants/EmailNotificationConstants";

let result = [];

class EmailStore extends EventEmitter {
  emitChange(eventName) {
    this.emit(eventName);
  }
  getResult() {
    return result;
  }
  setResult(_value) {
    result = _value;
  }
  addChangeListener(eventName, callback) {
    this.on(eventName, callback);
  }

  removeChangeListener(eventName, callback) {
    this.removeListener(eventName, callback);
  }
  handleCallback(action) {
    switch (action.type) {
      case EmailConstants.GET_EMAIL_DISTRIBUTION_GROUP_SUCCESS:
        this.setResult(action.result);
        break;
      case EmailConstants.GET_EMAIL_DISTRIBUTION_GROUP_FAILURE:
        this.setResult(action.result);
        break;
      case EmailConstants.ADD_OR_UPDATE_EMAIL_DISTRIBUTION_GROUP_SUCCESS:
        this.setResult(action.result);
        break;
      case EmailConstants.ADD_OR_UPDATE_EMAIL_DISTRIBUTION_GROUP_FAILURE:
        this.setResult(action.result);
        break;
      case EmailConstants.GET_EQIPMENT_FILTER_SUCCESS:
        this.setResult(action.result);
        break;
      case EmailConstants.GET_EQIPMENT_FILTER_FAILURE:
        this.setResult(action.result);
        break;
      case EmailConstants.SAVE_OR_UPDATE_EMAIL_SCHEDULE_SUCCESS:
        this.setResult(action.result);
        break;
      case EmailConstants.SAVE_OR_UPDATE_EMAIL_SCHEDULE_FAILURE:
        this.setResult(action.result);
        break;
      case EmailConstants.GET_SCHEDULE_EMAIL_SUCCESS:
        this.setResult(action.result);
        break;
      case EmailConstants.GET_SCHEDULE_EMAIL_FAILURE:
        this.setResult(action.result);
        break;
      case EmailConstants.REPLACE_EMAIL_SUCCESS:
        this.setResult(action.result);
        break;
      case EmailConstants.REPLACE_EMAIL_FAILURE:
        this.setResult(action.result);
        break;
      case EmailConstants.DELETE_SCHEDULE_EMAIL_SUCCESS:
        this.setResult(action.result);
        break;
      case EmailConstants.DELETE_SCHEDULE_EMAIL_FAILURE:
        this.setResult(action.result);
        break;
      // case EmailConstants.GET_SCHEDULE_EMAIL_BYID_SUCCESS:
      //   this.setResult(action.result);
      //   break;
      // case EmailConstants.GET_SCHEDULE_EMAIL_BYID_FAILURE:
      //   this.setResult(action.result);
      case EmailConstants.GET_SCHEDULE_EMAIL_ATTACHMENT_SUCCESS:
        this.setResult(action.result);
        break;
      case EmailConstants.GET_SCHEDULE_EMAIL_ATTACHMENT_FAILURE:
        this.setResult(action.result);
        break;
      default:
        break;
    }
    this.emitChange(action.type);
    return true;
  }
}

const emailStore = new EmailStore();
dispatcher.register(emailStore.handleCallback.bind(emailStore));
export default emailStore;
